import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Hero2 from "../components/Hero2";
import Message from "../components/Message";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div>

      <Hero />
      <Hero2 />
      <Message />
   
    </div>
  );
};

export default Home;
